
import { component } from '@/helpers/vueTyped';
import ContentBackground from './ContentBackground.vue';

interface HomeBackgroundProps {
  imageURL: string;
}

export default component<HomeBackgroundProps>()({
  name: 'HomeBackground',

  functional: true,

  render(h, context) {
   return (
     <fragment>
      <div class='background-shadow-to-right'/>
      <ContentBackground imageURL={context.props.imageURL}>
        <template slot='shadow'>
          <div class='background-shadow-to-bottom'/>
        </template>
      </ContentBackground>
     </fragment>
   );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-1405b9ff/HomeBackground.vue" });